import { render } from "./RoleEditHeader.vue?vue&type=template&id=13de73e2"
import script from "./RoleEditHeader.vue?vue&type=script&lang=js"
export * from "./RoleEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__